export { MedicationFaqs } from "./MedicationFaqs"
